import React, { useState } from "react";
import "./navbar.css";
import {
  MdMenu,
  MdArrowDropDown,
  MdArrowDropUp,
  MdMailOutline,
  MdPhone,
} from "react-icons/md";
import { Link, useNavigate, Outlet } from "react-router-dom";
import "./topnavsection.css";
import DropDownBtn from "../DropDownBtn";
import SingleDropDown from "../SingleDropDown";
const logo_animated1 = require("../../assets/1600X400_png.png");
const dwec_logo = require("../../assets/dwec_logo.png");

function Navbar(props) {
  // const [isActive, setIsActive] = useState();

  const navigate = useNavigate();
  const [colorChange, setColorchange] = useState(false);
  const changeNavbarColor = () => {
    if (window.scrollY >= 30) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);

  return (
    <>
      <nav
        className={
          colorChange || props.fromPage !== "home"
            ? "nav_bar_container nav_color_change"
            : "nav_bar_container"
        }
      >
        <div className="logo_container_nav_bar">
          <img
            src={logo_animated1}
            style={{ cursor: "pointer" }}
            alt="dwec_logo"
            className="dwec_logo"
            onClick={() => navigate("/Home")}
          />
        </div>
        <input type="checkbox" id="toggler1" />
        <label htmlFor="toggler1">
          <MdMenu />
        </label>
        <div className="logo_container_display">
          <div className="logo_container_disp">
            <img src={dwec_logo} alt="dwec_logo" className="dwec_logo" />
          </div>
        </div>
        <div className="menu_container">
          <div className="list_container">
            <li>
              <Link
                to="/"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/NewsUpdatesPage"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                News & Updates
              </Link>
            </li>
            <li>
              <Link
                to="/Blog"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                Blogs
              </Link>
            </li>

            <li>
              <Link
                to="/Countries"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                Explore Countries
              </Link>
            </li>
            <SingleDropDown
              colorChange={colorChange}
              fromPage={props.fromPage}
            />
            <DropDownBtn colorChange={colorChange} fromPage={props.fromPage} />
            {/* <li>
              <Link
                to="/BookCounselling"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                Book Online Counselling
              </Link>
            </li> */}
            <li>
              <Link
                to="/AboutUsMain"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/Conclave"
                className={
                  colorChange || props.fromPage !== "home"
                    ? "nav_link_text nav_change_color_text"
                    : "nav_link_text"
                }
              >
                DWEC Conclave 2022
              </Link>
            </li>
          </div>
        </div>
        <div
          className={
            colorChange || props.fromPage !== "home"
              ? "toll_free_number_container color_toll_free_no"
              : "toll_free_number_container"
          }
        >
          <li>
            <a href="tel:1800-230-700">
              <MdPhone className="social_icon_self" />
              <p className="toll_free_number_text">1800-1020-700</p>
            </a>
          </li>
          <li>
            <a href="mailto:info@dynamicwec.net">
              <MdMailOutline className="social_icon_self" />
              <p className="toll_free_number_text">info@dynamicwec.net</p>
            </a>
          </li>
        </div>
      </nav>

      <Outlet />
    </>
  );
}

export default Navbar;
